import React from 'react';
import { generateRandomString } from '@/utils/generateRandomString';
import { AvatarWithIconProps } from './AvatarWithIconPropsInterface';
import { AdminFeesIcon } from '../../data/TransactionTypeIcons';
import { IAdminTransaction } from '@/services/types/TransactionData';
import { getStyle } from './getStyle';
import { isCredit } from '../../utils/isCredit';

export const AdminTransactionIcon = (options: AvatarWithIconProps) => {
  const { transactionStatus, data } = options;
  const outlineStyle = getStyle(transactionStatus);
  if (isCredit((data.data as IAdminTransaction).sign)) {
    return (
      <div className={outlineStyle}>
        <div>
          <AdminFeesIcon id={`with-icon-${generateRandomString()}`} />
        </div>
      </div>
    );
  }

  return (
    <div className={outlineStyle}>
      <div>
        <AdminFeesIcon id={`with-icon-${generateRandomString()}`} />
      </div>
    </div>
  );
};
